module.exports = __webpack_public_path__ + "img/landscape.87e0a995.webp";